<template>
  <PageContent>
    <PanelV2
      type="w6"
      title="Enter your business details"
      @nextClick="commitData"
    >
      <template v-slot:content-solt>
        <AppForm
          ref="appForm"
          v-model="formData"
          :selectOptions="selectOptions"
          />
      </template>
    </PanelV2>
  </PageContent>
</template>

<script>
  import AppForm from "../forms/BdoMerchantA.val";
  import cityData from "../../common-data/city_select_data";
  import API from "@/api";
  export default {
    name: 'BdoMerchantA',
    pRouter: "WhetherBDOMerchant",
    components: {
      AppForm,
    },
    data() {
      return {
        formData: {},
        selectOptions: {
          "city_1": cityData,
        },
      }
    },
    methods: {
      commitData() {
        this.$refs.appForm.$refs.appForm.validate((valid) => {
          if (valid) {
            const data = this.formatCommitData({...this.formData, city: this.formData['city_1'], businessName: this.formData['businessName_1']})
            API.addBdoProcess({
              ...data
            }).then((res) => {
              if (res.success === true) {
                this.toNext();
              }
            });
          }
        });
      },
    }
  }
</script>


<style lang="scss" scoped>
.panel-v2.content-area {
  ::v-deep.content {
    margin-bottom: 160px;
  }
}
</style>
